import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { UserService } from '../.providers/user.service';
import * as global from '../global';
import { AuthService } from '../.providers/auth.service';
import { MainService } from '../.providers/main.service';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(
		private route: ActivatedRoute,
		private http: Http,
		private router: Router,
		private userService: UserService,
		private mainService: MainService,
		private authService: AuthService
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.authService.hasUserLoggedIn()) { 
			this.mainService.registerUser();
			return true;
		} else {
			// not logged in so redirect to login page with the return url
			this.router.navigate(['/login']); //, { queryParams: { returnUrl: state.url } });
			return false;
		}
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/.guard/auth.guard.ts